module.exports = __webpack_public_path__ + "4d08aff5d2b84a4bc6c3dc64704ddffe.svg";